import React from 'react';
import { useSelector } from 'react-redux';

import SettingsIcon from '@mui/icons-material/Settings';

import {
  Grid,
  Typography,
} from '@mui/material';

import AvatarWithStatus from './AvatarWithStatus';

const ContactBar = () => {
  const currentContact = useSelector((state) => {
    return state.nfChat.currentContact;
  });

  return (
    <Grid
      container
      sx={{
        backgroundColor: 'rgb(245, 245, 254)',
        padding: '10px 30px',
        alignItems: 'center',
        marginTop: '12px',
      }}
    >
      <Grid item xs={2}>
        <AvatarWithStatus contact={currentContact} />
      </Grid>
      <Grid item xs={8}>
        <Typography variant="h6">
          {currentContact?.other_user.name}
        </Typography>
      </Grid>
      <Grid item xs={2} sx={{ textAlign: 'right' }}>
        <SettingsIcon />
      </Grid>
    </Grid>
  );
};

export default ContactBar;
